import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=52c543f8&scoped=true&"
import script from "./ChangeHistory.vue?vue&type=script&lang=js&"
export * from "./ChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c543f8",
  null
  
)

export default component.exports